"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: 'ContractBasicInfo',
  props: {
    contract: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      form: {
        contractNo: '',
        type: '',
        dealerShopCode: '',
        dealerShopName: '',
        contractLevel: '',
        unmeasured: '',
        customerName: '',
        customerPhone: '',
        address: '',
        orderManagementNumber: '',
        amount: 0,
        budgetAmount: 0,
        orderType: '',
        contractImgs: [],
        file: ''
      }
    };
  },
  computed: {
    imgPreviewPrefix: function imgPreviewPrefix() {
      return this.$store.getters.imgPreviewPrefix;
    },
    filePreviewPrefix: function filePreviewPrefix() {
      return this.$store.getters.filePreviewPrefix;
    },
    // 计算合同图片URLs
    imageUrls: function imageUrls() {
      var _this = this;

      var imgs = this.form.contractImgs;

      if (typeof imgs === 'string') {
        try {
          imgs = JSON.parse(imgs);
        } catch (e) {
          console.error('解析 contractImgs 失败:', e);
          return [];
        }
      }

      if (!imgs || !Array.isArray(imgs)) {
        return [];
      }

      return imgs.map(function (img) {
        if (typeof img === 'string') {
          try {
            img = JSON.parse(img);
          } catch (e) {
            console.error('解析图片对象失败:', e);
            return '';
          }
        }

        return _this.imgPreviewPrefix + (img.realName || '');
      }).filter(function (url) {
        return url;
      });
    },
    // 计算附件URLs
    fileUrls: function fileUrls() {
      var _this2 = this;

      var fileData = this.form.file;

      if (!fileData) {
        return [];
      }

      if (typeof fileData === 'string') {
        try {
          fileData = JSON.parse(fileData);
        } catch (e) {
          console.error('解析 file 失败:', e);
          return [];
        }
      }

      if (!fileData || !Array.isArray(fileData)) {
        return [];
      }

      return fileData.map(function (file) {
        if (typeof file === 'string') {
          try {
            file = JSON.parse(file);
          } catch (e) {
            console.error('解析文件对象失败:', e);
            return null;
          }
        }

        return {
          name: file.alias || file.realName || '',
          url: file.url || _this2.filePreviewPrefix + (file.realName || '')
        };
      }).filter(function (file) {
        return file && file.name && file.url;
      });
    }
  },
  mounted: function mounted() {
    // 初始化表单数据
    this.initForm();
  },
  watch: {
    // 监听contract变化，重新加载数据
    contract: {
      handler: function handler(newVal) {
        if (newVal) {
          this.initForm();
        }
      },
      deep: true
    }
  },
  methods: {
    initForm: function initForm() {
      console.log("this.contract:", this.contract);

      if (this.contract) {
        // 处理合同图片
        var contractImgs = [];

        if (this.contract.contractImgs) {
          if (typeof this.contract.contractImgs === 'string') {
            try {
              contractImgs = JSON.parse(this.contract.contractImgs);
            } catch (e) {
              console.error('解析 contractImgs 失败:', e);
            }
          } else if (Array.isArray(this.contract.contractImgs)) {
            contractImgs = this.contract.contractImgs;
          }
        } // 处理附件


        var file = '';

        if (this.contract.file) {
          file = this.contract.file;
        }

        this.form = {
          contractNo: this.contract.contractNo || '',
          type: this.contract.type || '',
          dealerShopCode: this.contract.dealerShopCode || this.contract.shopNo || '',
          dealerShopName: this.contract.dealerShopName || this.contract.shopName || '',
          contractLevel: this.contract.contractLevel || '',
          unmeasured: this.contract.unmeasured || '',
          customerName: this.contract.contactPerson || '',
          customerPhone: this.contract.contactNumber || '',
          address: this.contract.contactAddress || '',
          orderManagementNumber: this.contract.orderManagementNumber || '',
          amount: this.contract.amount || 0,
          budgetAmount: this.contract.budgetAmount || 0,
          orderType: this.contract.orderType || '',
          contractImgs: contractImgs,
          file: file
        };
      }
    },
    // 打开文件
    openFile: function openFile(url) {
      try {
        window.open(url, '_blank');
      } catch (e) {
        console.error('打开文件失败:', e);
        this.$message.error('打开失败，请重试');
      }
    }
  }
};
exports.default = _default2;